import type { OverviewRow } from "./hooks";
import { formatDate } from "./utils";

type SelectionSummaryProps = {
  row: OverviewRow | null;
};

export function BlulogSelectionSummary({ row }: SelectionSummaryProps) {
  if (!row) return null;

  return (
    <section className="blulog-selection">
      <div>
        <h3>Suivi sélectionné</h3>
        <p className="blulog-selected-tracking">{row.trackingNumber}</p>
      </div>
      <dl className="blulog-selection-grid">
        <div>
          <dt>Capteur 1</dt>
          <dd>{row.id1 || "—"}</dd>
        </div>
        <div>
          <dt>Capteur 2</dt>
          <dd>{row.id2 || "—"}</dd>
        </div>
        <div>
          <dt>Première mesure</dt>
          <dd>{formatDate(row.firstMeasure)}</dd>
        </div>
        <div>
          <dt>Dernière mesure</dt>
          <dd>{formatDate(row.lastMeasure)}</dd>
        </div>
        <div>
          <dt>Organisation</dt>
          <dd>{row.organisation || "—"}</dd>
        </div>
        <div>
          <dt>Article</dt>
          <dd>{row.articleEi || "—"}</dd>
        </div>
        <div>
          <dt>Lieu du scan</dt>
          <dd>{row.scanLocation || "—"}</dd>
        </div>
        <div>
          <dt>Expéditions</dt>
          <dd>{row.expeditionCount}</dd>
        </div>
      </dl>
    </section>
  );
}
